import { months } from "@/i18n/vueI18n";

export function getMonth(date = new Date()) {
  const validDate =
    date instanceof Date && !isNaN(date.getTime()) ? date : new Date();
  return months()[validDate.getMonth()];
}
